import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_372c5601-80d9-473d-b6d0-4867dee1eff7/artifacts/vozwpjh6_logo.webp";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-[#1A1A1A]/5" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="md:col-span-2">
            <Link to="/" data-testid="footer-logo-link">
              <img
                src={LOGO_URL}
                alt="BE KIDS"
                className="h-10 w-auto mb-4"
                data-testid="footer-logo"
              />
            </Link>
            <p className="body-text text-sm max-w-md">
              BE KIDS — производитель умной детской мебели по методике Монтессори. 
              Экологичные товары из березовой фанеры высшего сорта для развития вашего ребенка.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="heading-3 text-base mb-4">Навигация</h4>
            <nav className="flex flex-col space-y-2">
              <Link to="/" className="nav-link text-sm" data-testid="footer-link-home">
                Главная
              </Link>
              <Link to="/#products" className="nav-link text-sm" data-testid="footer-link-products">
                Товары
              </Link>
              <Link to="/instructions" className="nav-link text-sm" data-testid="footer-link-instructions">
                Инструкция
              </Link>
              <Link to="/claims" className="nav-link text-sm" data-testid="footer-link-claims">
                Рекламации
              </Link>
            </nav>
          </div>

          {/* Marketplaces */}
          <div>
            <h4 className="heading-3 text-base mb-4">Маркетплейсы</h4>
            <nav className="flex flex-col space-y-2">
              <a
                href="https://www.wildberries.ru/brands/310481571-be-kids"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-link text-sm"
                data-testid="footer-link-wb"
              >
                Wildberries
              </a>
              <a
                href="https://www.ozon.ru/seller/be-kids-1234567/"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-link text-sm"
                data-testid="footer-link-ozon"
              >
                Ozon
              </a>
            </nav>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-[#1A1A1A]/5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-[#808080]" data-testid="copyright">
              © {currentYear} BE KIDS. Все права защищены.
            </p>
            <p className="text-xs text-[#808080]">
              Умная мебель для умных детей по методике Монтессори
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
